export { ComingSoonCollection } from './ComingSoonCollection'
